import type { Site } from '@/types/site';

export const updateRangeOptions = ['不限', '最近一周', '最近一月', '最近三月'] as const;
export const sortOptions = [
  { value: 'hot', label: '按热门度' },
  { value: 'new', label: '按更新时间' },
] as const;

export function formatVisits(value: number): string {
  if (value >= 100000000) return `${(value / 100000000).toFixed(1).replace(/\.0$/, '')}亿`;
  if (value >= 10000) return `${(value / 10000).toFixed(1).replace(/\.0$/, '')}万`;
  return String(value);
}

export function formatDate(dateStr: string): string {
  return dateStr.replace(/-/g, '.');
}

export function getRegions(list: Site[]): string[] {
  const set = new Set(list.map((item) => item.region));
  return Array.from(set);
}

export function getScales(list: Site[]): string[] {
  const order = ['顶级', '高', '中'];
  const set = new Set(list.map((item) => item.scale));
  return order.filter((item) => set.has(item));
}

export interface SiteFilterState {
  region: string;
  scale: string;
  updateRange: string;
}

export const defaultFilters: SiteFilterState = {
  region: '不限',
  scale: '不限',
  updateRange: '不限',
};

const rangeDays: Record<string, number> = {
  最近一周: 7,
  最近一月: 30,
  最近三月: 90,
};

export function filterSites(list: Site[], filters: SiteFilterState, reference: Date = new Date()): Site[] {
  const refTime = reference.getTime();
  return list.filter((item) => {
    if (filters.region !== '不限' && item.region !== filters.region) return false;
    if (filters.scale !== '不限' && item.scale !== filters.scale) return false;
    if (filters.updateRange !== '不限') {
      const limit = rangeDays[filters.updateRange];
      const added = new Date(`${item.addedAt}T00:00:00`).getTime();
      const diffDays = Math.floor((refTime - added) / 86400000);
      if (limit && diffDays > limit) return false;
    }
    return true;
  });
}

export function sortSites(list: Site[], sort: string): Site[] {
  const copy = [...list];
  if (sort === 'new') {
    copy.sort((a, b) => new Date(b.addedAt).getTime() - new Date(a.addedAt).getTime());
  } else {
    copy.sort((a, b) => b.visits - a.visits);
  }
  return copy;
}

export function searchSites(list: Site[], keyword: string): Site[] {
  const q = keyword.trim().toLowerCase();
  if (!q) return [];
  return list.filter((item) => {
    const haystack = [
      item.name,
      item.description,
      item.intro,
      item.domain,
      item.region,
      item.tags.join(' '),
    ]
      .join(' ')
      .toLowerCase();
    return haystack.includes(q);
  });
}

export function getRelatedSites(list: Site[], current: Site, limit = 5): Site[] {
  const others = list.filter((item) => item.id !== current.id);
  const scored = others.map((item) => {
    let score = 0;
    if (item.categoryId === current.categoryId) score += 3;
    score += item.tags.filter((tag) => current.tags.includes(tag)).length * 2;
    return { item, score };
  });
  scored.sort((a, b) => b.score - a.score || b.item.visits - a.item.visits);
  return scored.slice(0, limit).map((entry) => entry.item);
}